// © Microsoft Corporation. All rights reserved.
const mouseHandlers = {
    makeMouseOutFn: (elem, callback) => {
        const list = traverseChildren(elem);
        return function onMouseOut(event) {
            const e = event.toElement || event.relatedTarget;
            if (~list.indexOf(e)) {
                return;
            }
            callback();
        };
    },

    isElementHover: e => e.parentElement.querySelector(":hover") === e
};

function traverseChildren(elem) {
    const children = [];
    const q = [];
    q.push(elem);
    while (q.length > 0) {
        elem = q.pop();
        children.push(elem);
        pushAll(elem.children);
    }

    function pushAll(elemArray) {
        for (let i = 0; i < elemArray.length; i++) {
            q.push(elemArray[i]);
        }
    }
    return children;
}

function preventSelection(e) {
    document.body.style["-webkit-touch-callout"] = "none";
    document.body.style["-webkit-user-select"] = "none";
    document.body.style["-khtml-user-select"] = "none";
    document.body.style["-moz-user-select"] = "none";
    document.body.style["-ms-user-select"] = "none";
    document.body.style["user-select"] = "none";

    const removeNoSelect = () => {
        document.body.style["-webkit-touch-callout"] = "unset";
        document.body.style["-webkit-user-select"] = "unset";
        document.body.style["-khtml-user-select"] = "unset";
        document.body.style["-moz-user-select"] = "unset";
        document.body.style["-ms-user-select"] = "unset";
        document.body.style["user-select"] = "unset";
    };

    document.body.addEventListener("click", removeNoSelect, {once: true});
    document.body.addEventListener("mouseup", removeNoSelect, {once: true});
    document.body.addEventListener("touchend", removeNoSelect, {once: true});
}

function stopPropagationAndPreventDefault(e) {
    e.stopPropagation();
    e.preventDefault();
}

function getPointerCoordinatesByEvent(e) {
    let coords;
    if (e.type == "touchstart" || e.type == "touchmove" || e.type == "touchend" || e.type == "touchcancel") {
        const evt = (typeof e.originalEvent === "undefined") ? e : e.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        coords = {x: touch.clientX, y: touch.clientY};
    } else if (e.type == "mousedown" || e.type == "mouseup" || e.type == "mousemove" || e.type == "mouseover"|| e.type=="mouseout" || e.type=="mouseenter" || e.type=="mouseleave") {
        coords = {x: e.clientX, y: e.clientY};
    }

    return coords;
}

export {mouseHandlers, preventSelection, stopPropagationAndPreventDefault, getPointerCoordinatesByEvent};